import React, { Component } from 'react';
import { Button } from 'antd';

class PasswordTokenExpired extends Component {
	render() {
		return (			
			<div className="exterior-container">
				<div className="inner-exterior-container" style={{justifyContent: 'space-around'}}>
					<div className="info-container" style={{maxWidth: '365px'}}>
						<img src="./img/logo-efisco.png" alt="efisco" style={{marginBottom: '20px'}} />
						<h2 className="blue-text register-title title-text" style={{marginBottom: '10px'}}>
							Tu contraseña no puede ser actualizada
						</h2>
						<p className="label">
							El enlace que intentas actualizar ha expirado, favor de solicitar una nueva solicitud para reestablecer la contraseña.
						</p>
						<Button type="primary" onClick={()=> {this.props.history.push('/recover-password');}}>
							Cambiar contraseña
						</Button>
					</div>
				</div>
			</div>
		)
	}
}

export default (PasswordTokenExpired);